<template>
    <div id="duplicate-accounts">
        <generic-pager :currentCount="duplicateAccounts.length" :count="duplicateAccountsCount" :pageCount="pageCount" :lastObject="lastPagerObject" @update-list="updateList" :reset="resetList" :loading="isLoading">

            <div class="duplicate-accounts-list td-table-container mt-0" v-if="duplicateAccounts && duplicateAccounts.length >0">
                <table cellspacing="0" cellpadding="0" class="td-table">
                    <thead>
                        <tr class="table-header">
                            <th>Name</th>
                            <th>Status</th>
                            <th>Type</th>
                            <th>Modified</th>
                            <th>Phone #</th>
                            <th>City/State</th>
                            <th class="td-text-right"></th>
                        </tr>
                    </thead>
                    <tbody v-if="!isLoading && duplicateAccounts.length > 0" class="rows-container">
                        <tr class="table-row main-row" v-for="(duplicateAccount, index) in duplicateAccounts" :key="duplicateAccount.id">
                            <td class="name">
                                <a @click="goToAccount(duplicateAccount)">
                                    <h2 class="td-h5 mt-0">
                                        {{ duplicateAccount.ain }} - {{ duplicateAccount.n }}
                                    </h2>
                                </a>
                            </td>
                            <td class="status">
                                <span :class="getStatusClass(duplicateAccount.status)">{{ getStatus(duplicateAccount.status)}}</span>
                            </td>
                            <td class="type">
                                {{ getType(duplicateAccount.accountType) }}
                            </td>
                            <td class="modified">
                                {{ dateDisplay(duplicateAccount.modifiedDate) }}
                            </td>
                            <td class="office-number">
                                {{ formatPhoneString(duplicateAccount.info.officeNumber) }}
                            </td>
                            <td class="city-state">
                                {{ getAddress(duplicateAccount) }}
                            </td>

                            <td>
                                <a :href="'/accounts/admin/' + duplicateAccount.ain" class="td-btn secondary-outlined slim" title="View" @click="goToAccount(duplicateAccount)">
                                    View
                                </a>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-if="isLoading">
                        <tr><th colspan="5"><div class="loading"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                    </tbody>
                </table>

            </div>
        </generic-pager>
    </div>
    <div v-if="duplicateAccounts && duplicateAccounts.length < 1 && !isLoading" class="td-banner warning no-icon mt-2">
        <p>No duplicate accounts found.</p>
    </div>
</template>

<script>
    import script from './DuplicateAccounts';
    export default script;
</script>

<style lang="less">
    @import './DuplicateAccounts.less';
</style>